// src/views/TradePartner/CreateRepairEU.js
import React, { useState } from "react";
import {
  Card,
  CardContent,
  Grid,
  TextField,
  Button,
  Typography,
  IconButton,
  Box,
  makeStyles,
  Dialog, DialogTitle, DialogContent, DialogActions, useMediaQuery
} from "@material-ui/core";
import axios from 'src/utils/baseAxios';
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import AddressBlock from "src/components/TradePartner/AddressBlock";
import PhoneBlock from "src/components/TradePartner/PhoneBlock";
import {
  getUser
} from 'src/utils/Common';
import { useTheme } from "@material-ui/core/styles";
import ConsumerSearch from "src/components/Consumer/ConsumerSearch";
import { SearchIcon } from "@material-ui/data-grid";
import { normalizePhoneWithCountry } from "src/utils/phone";
import RepairInfoBlock from "src/components/TradePartner/RepairInfoBlock";
import AttachmentsBlock from "src/components/TradePartner/AttachmentsBlock";
import Alert from "@material-ui/lab/Alert";
import { useTranslation } from 'react-i18next';
import { getDialCodeByCountry } from "src/utils/countryHelper";

const useStyles = makeStyles((theme) => ({
  /* === ConsumerEntry ile aynı ana iskelet === */
  pageWrapper: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    minHeight: "calc(100vh - 100px)",
    background:
      "radial-gradient(1200px 600px at 30% -20%, #eaf2fb 0%, #f6f9fc 80%)",
    padding: theme.spacing(6, 2),
  },
  formCard: {
    width: "100%",
    maxWidth: 1280,
    borderRadius: 18,
    boxShadow:
      "0 10px 30px rgba(16,24,40,.06), 0 2px 6px rgba(16,24,40,.04)",
  },
  titleRow: {
    marginBottom: theme.spacing(3),
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
  },
  titleBar: {
    height: 3,
    width: "100%",
    background:
      "linear-gradient(90deg, #00B2FF 0%, #0079FF 60%, transparent 100%)",
    borderRadius: 2,
    marginTop: theme.spacing(1),
  },
  field: {
  "& .MuiOutlinedInput-root": {
    borderRadius: 14,
    backgroundColor: "#fff",
    transition: "all 0.2s ease-in-out",

    // ✅ hover efekti
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#4DA3FF",
    },

    // ✅ focus efekti
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderWidth: 2,
      borderColor: "#1B84FF",
      boxShadow: "0 0 6px rgba(27,132,255,0.3)",
    },
  },
  "& .MuiInputBase-input": {
    paddingTop: 14,
    paddingBottom: 14,
  },
},

  sectionLabel: {
    fontSize: 15,
    fontWeight: 700,
    color: "#1b84ff",
    margin: theme.spacing(1.5, 0, 1),
    display: "inline-block",
    position: "relative",
    "&::after": {
      content: '""',
      display: "block",
      width: 40,
      height: 3,
      background: "linear-gradient(90deg, #00B2FF, #0079FF)",
      borderRadius: 2,
      marginTop: 4,
    },
  },
  attachBox: {
    border: "1px dashed #c9d3e0",
    borderRadius: 14,
    padding: theme.spacing(1.5),
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  chip: { marginRight: theme.spacing(1) },
  /* === Buton yerleşimi (ConsumerEntry ile aynı davranış) ===
     - Küçük ekranlarda Submit ve Reset yan yana, ortalı
     - Büyük ekranlarda Submit tam ortada, Reset en sağda */
  buttonWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr auto 1fr",
    alignItems: "center",
    marginTop: theme.spacing(3),
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      gridTemplateColumns: "1fr 1fr",
      justifyItems: "center",
    },
  },
  submitBtn: {
    gridColumn: "2 / 3",
    padding: theme.spacing(1.25, 5),
    color: "#fff",
    fontWeight: 700,
    borderRadius: 999,
    background:
      "linear-gradient(90deg, #00B2FF 0%, #0079FF 100%)",
    boxShadow: "0 8px 20px rgba(0,121,255,0.22)",
    "&:hover": {
      background:
        "linear-gradient(90deg, #00A5F0 0%, #006EF0 100%)",
    },
    [theme.breakpoints.down("xs")]: {
      gridColumn: "1 / 2",
      width: "100%",
    },
  },
 resetIconButton: {
  gridColumn: "3 / 4",
  justifySelf: "end",
  padding: "0 18px",
  height: 44,
  borderRadius: 22,
  border: "2px solid #1b84ff",
  backgroundColor: "#ffffff",
  color: "#1b84ff",
  fontSize: 14,
  fontWeight: 600,
  letterSpacing: 0.3,
  textTransform: "none",
  transition: "all 0.25s ease",
  boxShadow: "0 2px 6px rgba(27,132,255,0.1)",

  "&:hover": {
    backgroundColor: "#1b84ff",
    color: "#ffffff",
    boxShadow: "0 4px 12px rgba(27,132,255,0.25)",
  },

  [theme.breakpoints.down("xs")]: {
    gridColumn: "2 / 3",
    justifySelf: "center",
  },
},

  alertBox: {
    borderRadius: "12px",
    fontSize: "0.95rem",
    fontWeight: 500,
    marginBottom: theme.spacing(2),
    "& .MuiAlert-icon": {
      fontSize: "1.4rem",
    },
  }
}));

export default function CreateRepairEU() {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const SessionUser = getUser();
  const [form, setForm] = useState({
    // Customer
    consumerId: 0, 
    name: "",
    surname: "",
    email: "",
    city: "",
    phone: [],
    // Repair
    asset: "",
    productSku: "",
    serialNr: "",
    applicationTypeId: "",
    warrantyType: "",
    warrantyDate: null,
    customerPrefDate: null,
    preferredSolution: null,
    dealerNr: "",
    comment: "",
    // Attach
    files: [], // {file, name, type}
    //ADDRESS
    Addresses: [{
        Country: "",
        AddressTypeId: 1,
        State: "",
        Region: "",
        City: "",
        District: "",
        Neighborhood: "",
        Street: "",
        Apartment: "",
        DoorNr: "",
        PostCode: "",
        AddressItem: "",
        Longitude: "",
        Latitude: "",
        PrimaryAddress: true,
    }],
  });
  const [submitting, setSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    type: "success",
    text: "",
  });
  const [isError, setIsError] = useState(false);  
  const [errors, setErrors] = useState({});
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openConsumerDialog, setOpenConsumerDialog] = useState(false);
  const [maskedMode, setMaskedMode] = useState(false);
  const [isNewAddress, setIsNewAddress] = useState(false);

  const tenantCountry =
  (SessionUser?.TenantCode || "").toUpperCase();

  const handleNewAddress = () => {
    setMaskedMode(false);
    setIsNewAddress(true);   //  ✔ yeni adres oluşturuluyor

    setForm(prev => ({
      ...prev,
      Addresses: [{
        Country: prev.Addresses?.[0]?.Country || tenantCountry,
        AddressTypeId: 1,
        State: "",
        Region: "",
        City: "",
        District: "",
        Neighborhood: "",
        Street: "",
        Apartment: "",
        DoorNr: "",
        PostCode: "",
        AddressItem: "",
        PrimaryAddress: true,
      }]
    }));
  };

  const REQUIRED_MSG = "This field is required!";

  const validate = () => {
    const e = {};

    // Customer Info
    if (!form.name.trim()) e.name = REQUIRED_MSG;
    if (!form.surname.trim()) e.surname = REQUIRED_MSG;

    // Phone
    if (!form.phone || form.phone.length === 0 || !form.phone[0]?.Phone?.trim()) {
        e.phone = REQUIRED_MSG;
    }

    // Address
    const addr = form.Addresses?.[0] || {};
    if (!addr.City?.trim()) e.city = REQUIRED_MSG;
    if (!addr.Street?.trim()) e.street = REQUIRED_MSG;
    if (!addr.PostCode?.trim()) e.postCode = REQUIRED_MSG;

    // Repair Info
    if (!form.productSku?.trim()) e.productSku = REQUIRED_MSG;
    if (!form.serialNr?.trim()) e.serialNr = REQUIRED_MSG;
    if (!form.applicationType?.trim()) e.applicationType = REQUIRED_MSG;
    if (!form.warrantyType) e.warrantyType = REQUIRED_MSG;
    if (!form.warrantyDate) e.warrantyDate = REQUIRED_MSG;
    if (!form.dealerNr) e.dealerNr = REQUIRED_MSG;
    if (!form.preferredSolution) e.preferredSolution = REQUIRED_MSG;

    // Tenant 68: attachment zorunlu
    if (SessionUser?.TenantId === 68 && (!form.files || form.files.length === 0)) {
      e.files = REQUIRED_MSG;
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };


  const reset = () => {
    setForm({
      // Customer
      consumerId: 0,
      name: "",
      surname: "",
      email: "",
      city: "",
      phone: [], 

      // Repair
      asset: "",
      productSku: "",
      serialNr: "",
      applicationType: "",
      warrantyType: "",
      warrantyDate: null,
      customerPrefDate: null,
      preferredSolution: null,
      dealerNr: "",
      comment: "",

      // Attachments
      files: [],

      // Address
      Addresses: [
        {
          Country: tenantCountry,
          AddressTypeId: 1,
          State: "",
          Region: "",
          City: "",
          District: "",
          Neighborhood: "",
          Street: "",
          Apartment: "",
          DoorNr: "",
          PostCode: "",
          AddressItem: "",
          Longitude: "",
          Latitude: "",
          PrimaryAddress: true,
        },
      ],
  });

  setErrors({});
  };

  const closeSnackbar = () => {
   setSnackbar({ open: false, type: "", text: "" });
  };

  const onSubmit = async () => {
  if (!validate()) return;
  setSubmitting(true);
  setSnackbar({ open: false, type: "", text: "" });

  try {
    const payload = {
      TechnicianId: SessionUser?.TechnicianId || 0,
      ConsumerId: form.consumerId || 0,
      Name: form.name,
      Surname: form.surname,
      Email: form.email,
      Phone: form.phone,
      IsNewAddress: isNewAddress,
      TenantId: SessionUser?.TenantId || 0,
      Addresses: form.Addresses.map((addr) => ({
        Country: addr.Country,
        AddressTypeId: addr.AddressTypeId,
        City: addr.City,
        District: addr.District,
        Neighborhood: addr.Neighborhood,
        State: addr.State,
        Region: addr.Region,
        Apartment: addr.Apartment,
        DoorNr: addr.DoorNr,
        Street: addr.Street,
        PostCode: addr.PostCode,
        AddressItem: addr.AddressItem,
        PrimaryAddress: addr.PrimaryAddress || false,
      })),
      Asset: form.asset,
      ProductSku: form.productSku,
      SerialNr: form.serialNr,
      ApplicationTypeId: form.applicationTypeId,
      WarrantyType: form.warrantyType,
      WarrantyDate: form.warrantyDate
        ? new Date(form.warrantyDate).toISOString().slice(0, 10)
        : null,
      CustomerPrefDate: form.customerPrefDate
        ? new Date(form.customerPrefDate).toISOString().slice(0, 10)
        : null,
      PreferredSolution: form.preferredSolution,
      DealerNr: form.dealerNr,
      Comment: form.comment,
      Files: form.files.map((f) => ({
        FileName: f.name,
        Type: f.type,
        MimeType: f.mimeType,
        FileData: f.base64,
      })),
    };

    const res = await axios.post("/tradepartner/create-repair-eu", payload, {
      headers: { "Content-Type": "application/json" },
    });

    const wrapper = res.data;         
    const response = wrapper?.Data;  


    if (
      wrapper?.Success &&
      response &&
      response.WorkOrderId > 0 &&
      response.WorkCaseId > 0 &&
      response.ConsumerId > 0
    ) {
      setIsError(false);
      setSnackbar({
        open: true,
        type: "success",
        text: `Successful operation. WorkOrderId: ${response.WorkOrderId}`,
      });
      reset();
    } else {
      setIsError(true);
      setSnackbar({
        open: true,
        type: "error",
        text: `The record could not be created. WorkOrderId: ${response?.WorkOrderId || 0}, WorkCaseId: ${response?.WorkCaseId || 0}, ConsumerId: ${response?.ConsumerId || 0}`,
      });
    }
  } catch (err) {
    console.error(err);
    setIsError(true);
    setSnackbar({
      open: true,
      type: "error",
      text: `Error: ${err.message}`,
    });
  } finally {
    setSubmitting(false);
  }
  };



const handleConsumerPick = (consumerData, row) => {
    const fullName =
        row?.Name ||
        row?.ConsumerName ||
        consumerData?.consumerFullName ||
        "";
  const selectedEmail =
    consumerData?.consumerEmail ||
    row?.Email ||
    row?.EMail ||
    "";

    const parts = fullName.trim().split(/\s+/);
    const firstName = parts[0] || "";
    const lastName = parts.slice(1).join(" ") || "";

    // --- TÜM TELEFONLAR ---
    const allPhones =
    (Array.isArray(consumerData?.Phones) &&
      consumerData.Phones.length > 0 &&
      typeof consumerData.Phones[0] === "object")
      ? consumerData.Phones
      : (row?.Phones ||
        (row?.Phone ? [{ Phone: row.Phone, PhoneType: 1 }] : []))

    // --- TELEFONLARI NORMALİZE ET ---
  const normalizedPhones = allPhones
    .map((p) => {
      if (!p?.Phone) return null;

      let raw = p.Phone.toString().trim();

      // Öncelik sırası:
      // 1️⃣ API'den gelen country
      // 2️⃣ Tenant country
      const countryCode =
        row?.Country ||
        SessionUser?.TenantCode ||
        "";

      // + ile gelmişse mevcut util'i kullan
      if (raw.startsWith("+")) {
        const normalized = normalizePhoneWithCountry(
          raw,
          countryCode?.toLowerCase(),
          SessionUser?.TenantCode?.toLowerCase()
        );

        return {
          PhoneType: p.PhoneType || 1,
          CountryCode: normalized.countryCode, // dial code
          Phone: normalized.phone,
        };
      }

      // + yoksa → countryHelper'dan dialCode al
      raw = raw.replace(/^0+/, "");

      const dialCode = getDialCodeByCountry(countryCode);

      return {
        PhoneType: p.PhoneType || 1,
        CountryCode: dialCode,
        Phone: raw,
      };
    })
    .filter(Boolean);

      // --- ADRES ---
      setForm((s) => {
        const mappedAddress = {
          Country:
            row?.Country ||
            row?.CountryCode ||
            s.Addresses?.[0]?.Country ||      
            SessionUser?.TenantCode ||
            "",
          AddressTypeId: row?.AddressTypeId ?? 1,
          State: row?.State ?? "",
          Region: row?.Region ?? "",
          City: row?.City ?? "",
          District: row?.District ?? "",
          Neighborhood: row?.Neighborhood ?? "",
          Street: row?.Street ?? "",
          Apartment: row?.Apartment ?? "",
          DoorNr: row?.DoorNr ?? "",
          PostCode: row?.PostCode ?? "",
          AddressItem: row?.Address ?? "",
          Longitude: row?.Longitude ?? "",
          Latitude: row?.Latitude ?? "",
          PrimaryAddress: row?.PrimaryAddress ?? true,
        };

        return {
          ...s,
          name: firstName || s.name,
          surname: lastName || s.surname,
          email: selectedEmail,
          phone: normalizedPhones,
          Addresses: [
            { ...(s.Addresses?.[0] || {}), ...mappedAddress },
          ],
          consumerId:
            row?.ConsumerId ||
            row?.Id ||
            consumerData?.consumerId ||
            consumerData?.ConsumerId ||
            consumerData?.Id ||
            s.consumerId,
        };
      });

      setMaskedMode(true);
      setIsNewAddress(false);
      setOpenConsumerDialog(false);
  };




  const handleChange = (field) => (e) => {
    const value = e?.target?.value ?? "";
    setForm((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" })); 
  };
  
  const GetConsumerForMaterialOrder = async (consumerId) => {
    try {
      if (!consumerId) return;
      setSubmitting(true);

      const url = `/technician/GetConsumerForMaterialOrder/null/null/${consumerId}/null`;
      const { data } = await axios.get(url);

      if (data && data.length > 0) {
        // SP JSON string döndürüyorsa parse et
        const parsed = typeof data === "string" ? JSON.parse(data) : data;

        const rows = parsed;
        const mainRow = rows[0];

        const rawPhones =
        Array.isArray(mainRow?.Phones) && mainRow.Phones.length > 0
          ? mainRow.Phones
          : rows
              .map((r) =>
                r?.Phone
                  ? {
                      Phone: r.Phone,
                      PhoneType: r.PhoneType || r.PhoneTypeId || 1,
                      CountryCode: r.CountryCode || "",
                    }
                  : null
              )
              .filter(Boolean);

      const phonesFromApi = rawPhones.filter((item, index, arr) => {
        return (
          index ===
          arr.findIndex(
            (x) =>
              String(x.Phone || "").trim() === String(item.Phone || "").trim() &&
              String(x.CountryCode || "").trim() === String(item.CountryCode || "").trim() &&
              Number(x.PhoneType || 0) === Number(item.PhoneType || 0)
          )
        );
      });

        const normalizedMainRow = {
          ...mainRow,
          ConsumerId: mainRow?.ConsumerId || mainRow?.Id,
        };

        handleConsumerPick(
          {
            ...normalizedMainRow,
            consumerId: normalizedMainRow.ConsumerId,
            Phones: phonesFromApi,
          },
          normalizedMainRow
        );
      } else {
        console.warn("No consumer found for ID:", consumerId);
      }
    } catch (e) {
      console.error("Error:", e);
    } finally {
      setSubmitting(false);
    }
  };


  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <div className={classes.pageWrapper}>
        <Card className={classes.formCard}>
          <CardContent>
            <div className={classes.titleRow}>
              <Typography className={classes.title}>
                {t("createRepairForCustomer")}
              </Typography>
              <div className={classes.titleBar} />
            </div>

            {/* CUSTOMER & ADDRESS INFO */}
            <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <Typography className={classes.sectionLabel}>
                  👤{t("customerInfo")}
                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={5}>
                    <TextField
                        className={classes.field}
                        variant="outlined"
                        fullWidth
                        value={form.name}
                        onChange={handleChange("name")}
                        placeholder={t("name")}
                        error={!!errors.name}
                        helperText={errors.name}
                    />
                    </Grid>
                    <Grid item xs={12} sm={5}>
                    <TextField
                        className={classes.field}
                        variant="outlined"
                        fullWidth
                        value={form.surname}
                        onChange={handleChange("surname")}
                        placeholder={t("surname")}
                        error={!!errors.surname}
                        helperText={errors.surname}
                    />
                    </Grid>
                    <Grid item xs={12} sm={2} style={{ display: "flex", alignItems: "stretch" }}>
                        <Button
                            onClick={() => setOpenConsumerDialog(true)}
                            fullWidth
                            className={classes.submitBtn}
                        >
                             <SearchIcon fontSize="small" />
                                      
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                    <TextField
                      className={classes.field}
                      variant="outlined"
                      fullWidth
                      value={form.email}
                      onChange={handleChange("email")}
                      placeholder={t("email")}
                      error={!!errors.email}
                      helperText={errors.email}
                    />
                    </Grid>
                    <Grid item xs={12}>
                        <PhoneBlock
                            value={form.phone || []}
                            onChange={(phones) => setForm((prev) => ({ ...prev, phone: phones }))}
                            sessionUser={SessionUser}
                            required={false}
                            error={errors.phone}
                            onSelectExistingConsumer={GetConsumerForMaterialOrder}
                        />
                    </Grid>
                </Grid>
                </Grid>

                <Grid item xs={12} md={6}>
                    <Typography className={classes.sectionLabel}>
                      📍{t("addressInfo")}
                    </Typography>
                    <Button
                      variant="outlined"
                      onClick={handleNewAddress}
                      style={{
                        marginLeft: 12,
                        borderRadius: 10,
                        padding: "4px 14px",
                        fontWeight: 600,
                        textTransform: "none",
                        borderColor: "#1b84ff",
                        color: "#1b84ff",
                      }}
                    >
                      {t("lblNewAddress", "New Address")}
                    </Button>
                    <AddressBlock
                    value={form.Addresses[0]}
                    maskedMode={maskedMode}
                    onChange={(addr) => {
                        const updated = [...form.Addresses];
                        updated[0] = addr;
                        setForm({ ...form, Addresses: updated });
                    }}
                    sessionTenantId={SessionUser?.TenantId}
                    errors={errors}
                    />
                </Grid>
            </Grid>

            {/* REPAIR INFO */}
            <Box mt={3} />
            <Grid container spacing={2}>
              <RepairInfoBlock
                form={form}
                setForm={setForm}
                errors={errors}
                handleChange={handleChange}
                sessionTenantId={SessionUser?.TenantId}
                />
            </Grid>

            {/* ATTACHMENTS */}
            <Grid item xs={12}>
              <AttachmentsBlock form={form} setForm={setForm} errors={errors} />
            </Grid>

            {/* ✅ Message */}
            {snackbar.open && (
            <Box mb={2}>
                <Alert
                className={classes.alertBox}
                severity={snackbar.type}
                onClose={() => setSnackbar({ ...snackbar, open: false })}
                >
                {snackbar.text}
                </Alert>
            </Box>
            )}

            {/* BUTTON*/}
            <div className={classes.buttonWrapper}>
                <span />
                <Button
                    className={classes.submitBtn}
                    onClick={onSubmit}
                    disabled={submitting}
                >
                    {submitting ? t("sending") : t("submit")}
                </Button>
                <Button
                  className={classes.resetIconButton}
                  onClick={() => {
                    closeSnackbar();
                    reset();
                  }}
                >
                  {t("lblRefresh", "Refresh")}
                </Button>
            </div>
            <Dialog
                open={openConsumerDialog}
                onClose={() => setOpenConsumerDialog(false)}
                fullScreen={fullScreen}
                maxWidth="lg"
                fullWidth
                PaperProps={{
                    style: {
                    borderRadius: fullScreen ? 0 : 16,
                    overflow: "hidden",
                    },
                    elevation: 3,
                }}
            >
            <DialogTitle style={{ fontWeight: 700 }}>
                {t("consumerSearch")}
            </DialogTitle>

            <DialogContent dividers style={{ padding: 16 }}>
                <ConsumerSearch
                handleClick={handleConsumerPick}
                ConsumerPhone={
                    Array.isArray(form.phone) && form.phone[0]?.Phone
                    ? form.phone[0].Phone
                    : (form.phone || "")
                }
                />
            </DialogContent>

            <DialogActions style={{ padding: 12 }}>
                <Button
                onClick={() => setOpenConsumerDialog(false)}
                style={{
                    borderRadius: 999,
                    textTransform: "none",
                    fontWeight: 700
                }}
                >
                {t("close")}
                </Button>
            </DialogActions>
            </Dialog>

          </CardContent>
        </Card>
      </div>
    </MuiPickersUtilsProvider>
  );
}
